import React from 'react'
import ImageHeader from '../../component/ImageHeader'
import AboutGallery from './AboutGallery'
import AboutStay from './AboutStay'
import ContactHead from '../Contact/ContactHead'
import AboutMind from './AboutMind'
import AboutProperty from './AboutProperty'

export default function About() {
    const imageHead = {
        title: 'The De Coração Experience: Hospitality with a Personal Touch',
        image: "../image/about-banner.webp",
        breadcrumb: [
        {
            name: "About Us",
        },
        ]
    }

    const quoteHead = {
        desc: "We all need moments to hit pause and escape the noise of daily life. At De Coração, we prioritize these desires, whether you’re on the beaches of Goa, in the forests of Jim Corbett, or by the river in Rishikesh. Our goal is to make you feel at home. True luxury lies in a comforting space and the warmth of caring people. Settle in, let go of stress, and rediscover what it means to be truly well-rested.",
        title: "An Overview",
    };


    const galleryOne = {
        desc: "",
        image1: "/image/about-image-1.webp" ,
        image2: "/image/about-image-2.webp" ,
    };

    const galleryTwo = {
        desc: "At De Coração, we believe true luxury lies in how you feel—cared for, connected, and completely at ease. We invite you to experience a place where every moment is thoughtfully crafted to leave a lasting impression on your heart.",
        image1: "/image/about-image-3.webp" ,
        image2: "/image/about-image-4.webp" ,
    };

  return (
    <>
        <ImageHeader imageHead={imageHead}/>
        <ContactHead quoteHead={quoteHead}/>
        <AboutGallery galleryData={galleryOne}/>
        <AboutStay/>
        <AboutMind/>
        <AboutGallery galleryData={galleryTwo}/>
        <AboutProperty/>
    </>
  )
}
